/*
 * AppNavigation
 *
 * What the embedded app says its own navigation is.
 *
 * The app is the only place that can decide this: sections are granted per Comm
 * Link, the assistant depends on a per-network flag, and the labels are
 * translated inside the app. Hard coding them here would guarantee drift the
 * first time a section is added or a permission changes.
 *
 * The frame view receives them and this holds them, so the header can render
 * them without either component knowing about the other. Same listener shape as
 * Route.js, for the same reason - there is one place the value lives and
 * everything else subscribes.
 */

const listeners = [];

let current = {
    activeSection: null,
    authenticated: false,
    sections: []
};

// Sign out is a request, not a state change - the app owns the session and
// answers with a navigationChanged of its own. Kept here rather than on the
// frame view so the header can ask without knowing what is rendering the app.
const sign_out_listeners = [];

const Navigation = {

    get: () => current,

    requestSignOut: () => {
        sign_out_listeners.forEach(listener => {
            try {
                listener();
            } catch(e) {
                console.error(`App sign out listener failed: ${e.message}`);
            }
        });
    },

    subscribeToSignOut: listener => {
        sign_out_listeners.push(listener);
        return () => {
            let index = sign_out_listeners.indexOf(listener);
            if(index >= 0) {
                sign_out_listeners.splice(index, 1);
            }
        };
    },

    set: next => {
        current = {
            activeSection: next?.activeSection || null,
            authenticated: next?.authenticated === true,
            sections: Array.isArray(next?.sections) ? next.sections.slice().sort((a, b) => {
                return (a.order || 0) - (b.order || 0);
            }) : []
        };
        listeners.forEach(listener => {
            try {
                listener(current);
            } catch(e) {
                console.error(`App navigation listener failed: ${e.message}`);
            }
        });
    },

    subscribe: listener => {
        listeners.push(listener);
        return () => {
            let index = listeners.indexOf(listener);
            if(index >= 0) {
                listeners.splice(index, 1);
            }
        };
    }
};

export default Navigation;
